// The staff interface language (docs/plans/phase3-portal-feedback-kiswahili.md §8): each
// person's own setting, so any signed-in user may read and change it.
import { userLanguageSchema, type UiLanguage } from '@wodi/shared';
import { queryOptions } from '@tanstack/react-query';

import { api } from './client.ts';

export const languageQuery = queryOptions({
  queryKey: ['me', 'language'],
  queryFn: () => api('GET', '/me/language', { schema: userLanguageSchema }),
});

export function updateLanguage(language: UiLanguage) {
  return api('PUT', '/me/language', { body: { language }, schema: userLanguageSchema });
}
